import { proIPKey, ip2LocationKey } from "../utils/general-config";
import axios from "axios";
import { LOCALE, PORTAL_CD } from "../utils/constants";
import { availableLanguages } from "../i18nextInit";
import FunnelStepTypes from "../pages/funnel-step/types";

export const readCookie = (name) => {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const createCookie = (name, value, days, domain) => {
  var expires = "";
  var _domain = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toGMTString();
  } else expires = "";

  if (domain) {
    _domain = "; domain=" + domain;
  }
  document.cookie =
    name + "=" + value + expires + _domain + "; path=/; Secure; SameSite=Lax";
};

export const deleteCookie = (name) => {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};

export const getIPConfig = async (dispatch = null) => {
  let ipAddress = readCookie("ipAddress");
  let proIpUrl = "https://pro.ip-api.com/json?key=" + proIPKey();
  if (!!ipAddress) {
    proIpUrl =
      "https://pro.ip-api.com/json/" + ipAddress + "?key=" + proIPKey();
  }
  try {
    let proIpResponse = await axios.get(
      proIpUrl +
        "&fields=country,countryCode,status,query,currency,region,zip,city",
    );
    if (
      !!proIpResponse &&
      !!proIpResponse.data &&
      proIpResponse.data.status === "success" &&
      !!proIpResponse.data.zip
    ) {
      createCookieBaseOnProIpResponse(
        proIpResponse.data.countryCode,
        proIpResponse.data.currency,
        proIpResponse.data.status,
        proIpResponse.data.query,
        proIpResponse.data.region,
        proIpResponse.data.zip,
        proIpResponse.data.city,
        ipAddress,
        dispatch,
      );
    } else {
      await callIP2LocationAPI(ipAddress, dispatch);
    }
  } catch (error) {
    // Call IP2 location API as fallback
    await callIP2LocationAPI(ipAddress, dispatch);
  }
};

export const callIP2LocationAPI = async (ipAddress, dispatch = null) => {
  try {
    let ip2LocationUrl = "https://api.ip2location.io/?key=" + ip2LocationKey;
    if (!!ipAddress) {
      ip2LocationUrl += "&ip=" + ipAddress;
    }
    let ip2Response = await axios.get(ip2LocationUrl);
    if (!!ip2Response && !!ip2Response.data) {
      createCookieBaseOnProIpResponse(
        ip2Response.data.country_code,
        ip2Response.data.country?.currency?.code,
        "success",
        ip2Response.data.ip,
        ip2Response.data.region_name,
        ip2Response.data.zip_code,
        ip2Response.data.city_name,
        ipAddress,
        dispatch,
      );
    }
  } catch (ip2Error) {
    console.log("IP2 location API also failed ", ip2Error);
  }
};
export function checkIP(ipAddress) {
  const ipv4Regex =
    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){2}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

  const ipv6Regex =
    /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|(::1)|(([0-9a-fA-F]{1,4}:){1,6}:)|(:{2}[0-9a-fA-F]{1,4}))$/;

  const isIPv4 = ipv4Regex.test(ipAddress);
  const isIPv6 = ipv6Regex.test(ipAddress);
  const isValid = isIPv4 || isIPv6;

  let isPrivate = false;
  let isLoopback = false;

  if (isIPv4) {
    const parts = ipAddress.split(".").map(Number);
    if (
      parts[0] === 10 ||
      (parts[0] === 172 && parts[1] >= 16 && parts[1] <= 31) ||
      (parts[0] === 192 && parts[1] === 168)
    ) {
      isPrivate = true;
    }
    if (parts[0] === 127) {
      isLoopback = true;
    }
  }

  if (isIPv6) {
    // ::1 is loopback
    if (ipAddress === "::1") {
      isLoopback = true;
    }
    // fc00::/7 is private (unique local address)
    if (/^fc|^fd/i.test(ipAddress)) {
      isPrivate = true;
    }
  }

  return {
    ip: ipAddress,
    isValid,
    isIPv4,
    isIPv6,
    isPrivate,
    isPublic: isValid && !isPrivate,
    isLoopback,
  };
}

const createCookieBaseOnProIpResponse = (
  country,
  currency,
  ipStatus,
  query,
  region,
  zip,
  city,
  ipAddress,
  dispatch = null,
) => {
  // if (!ipAddress) {
  //   createCookie("ipAddress", query);
  // }
  // createCookie("country", country);
  // createCookie("currency", currency);
  // createCookie("proipstatus", ipStatus);
  // createCookie("zip", zip);
  // createCookie("region", region);
  // createCookie("city", city);

  // Store country and currency in funnel step
  if (dispatch) {
    dispatch(
      PushUserInformationToFunnelStep({
        countryCD: country,
        currencyCD: currency,
        ipAddress: ipAddress || query,
        city: city,
        region: region,
        zip: zip,
      }),
    );
  }
};

const PushUserInformationToFunnelStep = (userInformation) => ({
  type: FunnelStepTypes.SET_USERINFO,
  payload: userInformation,
});

export const getPortalCD = (locale) => {
  let portal = PORTAL_CD.IT;
  if (!!locale && locale !== "en") portal = portal + locale.toUpperCase();
  return portal;
};

export const getLocale = (culture) => {
  let locale = LOCALE.EN;
  return locale;
};

export const loadScript = (url) => {
  const script = document.createElement("script");
  script.src = url;
  document.head.appendChild(script);
};

export const removeScript = (url) => {
  var scripts = document.getElementsByTagName("script");
  for (let script of scripts) {
    if (script.src === url) {
      script.remove();
      break;
    }
  }
};

export const setLocaleURL = (url, locale) => {
  let verifiedLocale = "en";
  if (!!locale) {
    if (availableLanguages.indexOf(locale) > -1) {
      verifiedLocale = locale;
    }
  }
  return url.replace(":locale", verifiedLocale);
};

export const isAllAddressCookiePresent = () => {
  if (
    !!readCookie("ipAddress") &&
    !!readCookie("currency") &&
    !!readCookie("zip") &&
    !!readCookie("city") &&
    !!readCookie("region") &&
    !!readCookie("country")
  ) {
    return true;
  } else {
    return false;
  }
};
